import type { ReactNode } from 'react';

interface SkeletonGridProps {
  prefix: string;
  count: number;
  className: string;
  children: (key: string) => ReactNode;
}

export function SkeletonGrid({ prefix, count, className, children }: SkeletonGridProps) {
  const keys = Array.from({ length: count }, (_, i) => `${prefix}-${i}`);
  return <div className={className}>{keys.map((key) => children(key))}</div>;
}
